import { term } from '../../../../packages/JsonQuery';
import { TReduxActions } from '../../actions';
import { EFetchMapDataActionType } from '../../actions/fetchMapData/types';
import { EResultsActionType } from '../../actions/results';
import { EResultsStatus, IResultsState } from '../../types/results';

const defaultState: IResultsState = {
  status: EResultsStatus.Initial,
  jsonQuery: {
    _type: 'flatrent',
    engine_version: term(2),
  },
  dominantSubdomain: 'www',
  dominantRegionId: null,
  sortedOfferIds: [],
  offersCount: 0,
};

export function resultsReducer(state: IResultsState = defaultState, action: TReduxActions): IResultsState {
  switch (action.type) {
    case EFetchMapDataActionType.Loading:
      return {
        ...state,
        status: EResultsStatus.Loading,
      };

    case EFetchMapDataActionType.Failed:
      return {
        ...state,
        status: EResultsStatus.Failed,
      };

    case EFetchMapDataActionType.Succeed:
      return {
        ...state,
        status: EResultsStatus.Succeed,
        jsonQuery: action.payload.jsonQuery as IResultsState['jsonQuery'],
        sortedOfferIds: action.payload.sortedOfferIds,
        offersCount: action.payload.offersCount,
        version: action.payload.clean ? Symbol() : state.version,
      };

    case EResultsActionType.SetDominantSubdomain:
      return {
        ...state,
        dominantSubdomain: action.payload,
      };

    case EResultsActionType.SetDominantRegionId:
      return {
        ...state,
        dominantRegionId: action.payload,
      };
  }

  return state;
}
